import { Outlet, useParams } from 'react-router'
import Spacing from '../UI/Spacing'
import { IoIosArrowBack, IoIosArrowForward, IoMdArrowForward } from 'react-icons/io'
import { Link } from 'react-router-dom'
import i18next from 'i18next'

export default function CleanEnergyTechnologiesArticleLayout() {
  const { lng } = useParams()
  return (
    <>
      <Spacing />
      <div className="app-container px-8 lg:px-0">
        <div className="mb-4 flex">
          <Link
            to={`/${lng}/future-minerals/clean-energy/technologies`}
            className="bg-primary-600 border-primary-600 hover:text-primary-600 hover:border-secondary-600 hover:bg-muted-300 flex border-2 p-3 text-white"
          >
            <IoMdArrowForward className="h-6 w-6 ltr:rotate-180" />
          </Link>
        </div>
        <Outlet />
      </div>
    </>
  )
}
